/**
 * Two-role IA routes (Get Work Done / Work & Earn)
 * Mounted at app root — takes precedence over legacy catch-alls where listed first.
 * Browse stays on marketing; login / post project / buy / orders go to zoopupweb-app.
 */
import {
  appLoginUrl,
  appSignupUrl,
  appDashboardUrl,
  appProjectsCreateUrl,
  appMicroJobOrdersUrl,
  redirectIfExternalAppAuth,
  redirectToAppUrl,
} from '../twoRole/config/appLinks';

const twoRoleRoutes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../twoRole/pages/HomePage.vue'),
    meta: { twoRole: true },
  },
  {
    path: '/login',
    name: 'login-v2',
    component: () => import('../twoRole/auth/LoginV2.vue'),
    meta: { twoRole: true, guest: true },
    beforeEnter: redirectIfExternalAppAuth(appLoginUrl),
  },
  {
    path: '/signup',
    name: 'signup-v2',
    component: () => import('../twoRole/auth/SignupV2.vue'),
    meta: { twoRole: true, guest: true },
    beforeEnter: redirectIfExternalAppAuth(appSignupUrl),
  },
  {
    path: '/signup/intent',
    name: 'signup-intent',
    component: () => import('../twoRole/auth/IntentPicker.vue'),
    meta: { twoRole: true },
    beforeEnter: redirectIfExternalAppAuth(appSignupUrl),
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../twoRole/pages/DashboardPage.vue'),
    meta: { twoRole: true, requiresAuth: true },
    beforeEnter: redirectToAppUrl(appDashboardUrl),
  },
  {
    path: '/microjobs',
    name: 'micro-jobs-catalog',
    component: () => import('../twoRole/pages/MicroJobsCatalogPage.vue'),
    meta: { twoRole: true },
  },
  {
    path: '/microjobs/orders',
    name: 'micro-jobs-orders',
    beforeEnter: redirectToAppUrl(appMicroJobOrdersUrl),
  },
  {
    path: '/microjobs/:id',
    name: 'micro-job-detail',
    component: () => import('../twoRole/pages/MicroJobDetailPage.vue'),
    meta: { twoRole: true },
  },
  { path: '/micro-jobs', redirect: '/microjobs' },
  { path: '/micro-jobs/orders', redirect: '/microjobs/orders' },
  { path: '/micro-jobs/:id', redirect: to => `/microjobs/${to.params.id}` },
  { path: '/dashboard/micro-jobs', redirect: '/microjobs' },
  { path: '/dashboard/micro-jobs/orders', redirect: '/microjobs/orders' },
  { path: '/dashboard/micro-jobs/:id', redirect: to => `/microjobs/${to.params.id}` },
  {
    path: '/services',
    redirect: '/hire',
  },
  {
    path: '/projects/new',
    beforeEnter: redirectToAppUrl(appProjectsCreateUrl),
  },
  {
    path: '/projects/create',
    beforeEnter: redirectToAppUrl(appProjectsCreateUrl),
  },
  {
    path: '/projects',
    redirect: '/freelancer/projects',
  },
  {
    path: '/sell/services',
    redirect: '/freelancer/projects',
  },
  {
    path: '/sell/services/new',
    redirect: '/freelancer/training_classes',
  },
  {
    path: '/teach',
    redirect: '/freelancer/training_classes',
  },
  {
    path: '/settings',
    redirect: '/newclient/settings',
  },
];

export default twoRoleRoutes;
